// Configuration for the frontend application

// Set to true to attempt fetching data from the backend.
// Set to false to use only the local JSON data (faster load, no backend required).
export const ENABLE_BACKEND = false;
